import BingMaps from 'ol/source/BingMaps';
import olMap from 'ol/Map';
import LayerGroup from 'ol/layer/Group';

export class BingSession {

    private _bingSessionKey: string = "";
    private _bingMapControl: any;

    //60 & 30s minutes in miliseconds
    private _sessionTimeOut: number = 3630000;
    private _olMap: olMap;


    public constructor() {

    }

    public init = (apiKey: string, successCallback: Function, failureCallback: Function): void => {
        let mapContainer = $("#mapContainer");
        let bingMapContainer = $("<div id='bingMap'></div>")
        let self = this;

        mapContainer.append(bingMapContainer);

        try {           
            // @ts-ignore
            self._bingMapControl = new Microsoft.Maps.Map(document.getElementById('bingMap'), {
                credentials: apiKey,
                // @ts-ignore
                center: new Microsoft.Maps.Location(51.50632, -0.12714),
                // @ts-ignore
                mapTypeId: Microsoft.Maps.MapTypeId.aerial,
                zoom: 10
            });

            self._bingMapControl.getCredentials(function (sessionId) {
                if (sessionId) {
                    self._bingSessionKey = sessionId;
                    successCallback.call(this, self._bingSessionKey);
                    //now hide the bing map
                    bingMapContainer.hide();

                    //timeout handler not needed
                    //session is 1 hour on localhost but 2 days on the actual site
                    //window.setTimeout(function () {
                    //    handleBingSessionRefresh();
                    //}, sessionTimeOut);
                }
                else {
                    failureCallback.call(this);
                }
                
            });
        }
        catch {
            failureCallback.call(this);
        }        
    }

    public getSessionKey = (): string => {
        return this._bingSessionKey;
    }

    private handleBingSessionRefresh = (): void => {
        let self = this;

        self._bingMapControl.getCredentials(function (sessionId) {
            self._bingSessionKey = sessionId;

            function setSource(layer, imagerySet) {
                layer.setSource(new BingMaps({
                    key: self._bingSessionKey,
                    imagerySet: imagerySet,
                    culture: 'en-gb',
                    maxZoom: 17
                }));
            }

            self._olMap.getLayers().forEach(function (layer, j) {
                if (layer instanceof LayerGroup) {
                    layer.getLayers().forEach(function (baseLayer) {
                        switch (baseLayer.get("name")) {
                            case "BingAerialWithLabels":
                                setSource(baseLayer, "AerialWithLabelsOnDemand");
                                break;

                            case "BingAerial":
                                setSource(baseLayer, "Aerial");
                                break;

                            case "BingRoad":
                                setSource(baseLayer, "RoadOnDemand");
                                break;

                            case "BingOrdnanceSurvey":
                                setSource(baseLayer, "OrdnanceSurvey");
                                break;
                        }
                    });
                }
            });


            window.setTimeout(function () {
                self.handleBingSessionRefresh();
            }, self._sessionTimeOut);
        });
    }

    public setMap = (map: olMap): void => {
        this._olMap = map;
    }

}